import moment from 'moment';
import FormMixin from '@/mixins/formvalid'
import gInput from '@/components/googlemaps/gInput';
import MDistanceDetails from '@/components/booking/distance_details';
import RouteMap from '@/components/googlemaps/routeMap'

export default {
  mixins: [FormMixin],
  props: ['dialog', 'form', 'booking'],
  components: {
    'm-route-map': RouteMap,
    'm-distance-detail': MDistanceDetails,
    'g-input': gInput
  },
  data () {
    return {
      menu_time: false,
      menu_waittime: false,
      menu_date: false,
      dateFormatted: null,
      datesFormatted: [],
      drivers: [],
      clients: [],
      destinations: [],
      insurances: [],
      driverObj: null,
      clientObj: null,
      destinationObj: null,
      insuranceObj: null,
      distance_result: null,
      waitprice: 0,
      waittime: '0',
      hideWait: false,
      bookingType: null,
      timeBefore: 15,
      retour: false,
      accepted: 0,
      modes: ['pending', 'closed', 'unfounded', 'canceled'],
      status: [
        {text: 'pending', value: 0},
        {text: 'closed', value: 1},
        {text: 'unfounded', value: 2},
        {text: 'canceled', value: 3}
      ],
      acceptedList: [
        {text: 'assign', value: 0},
        {text: 'pending', value: 1}
      ],
      types: [
        {text: 'Aller', value: 'to'},
        {text: 'Retour', value: 'back'},
        {text: 'Simple', value: 'simple'}
      ],
      waits: ['0', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00'],
      motives: [
        {text: 'Radiotherapy', value: 1},
        {text: 'Kinetherapy', value: 2},
        {text: 'Fréquentation', value: 3},
        {text: 'Consultation', value: 4},
        {text: 'Dialysis', value: 5},
        {text: 'Chemotherapy', value: 6},
        {text: 'Shopping', value: 7},
        {text: 'Hospitalisation', value: 8},
        {text: 'No motive', value: 0}
      ],
      distance: {clientId: null, destinationId: null, driverId: null},
      mutual: false,
      pickadress_notValid: false,
      pick_address: null,
      factuur: false,
      factuurDriver: false,
      creditDriver: false,
      nonReimbursed: {}
    }
  },
  methods: {
    toggleMutual (v) {
      if (!v) {
        this.resetMutual();
      }
    },

    resetMutual () {
      this.form.fields.mutualComment = null;
      this.form.fields.mutualPatientID = null;
      this.form.fields.min10km = 0;
      this.form.fields.plus10km = 0;
      this.form.fields.mutualDistance = null;
      this.form.fields.mutualPatientAmount = 0;
      this.form.fields.noMutIntervention = null;
      this.form.fields.mutualAmount = 0;
      this.form.fields.insuranceId = null;
      this.form.fields.certificateNeeded = null;
      this.form.fields.certificateReceived = null;
      this.insuranceObj = null;
      this.nonReimbursed = {};
    },
    toggleCredit (v) {
      if (!v) {
        this.resetCredit();
      }
    },
    resetCredit () {
      this.form.fields.creditDriver = null;
      this.form.fields.creditAmount = null;
      this.form.fields.creditReason = null;
    },
    typeChange (item) {
      this.resetWait();
      this.setType(item);
    },
    toggleBack (value) {
      this.form.back = value;
      if (!this.form.back) {
        delete this.form.back;
      }
    },
    toggleMultiple (value) {
      this.form.multiple = value;
      if (!this.form.multiple) {
        delete this.form.multiple;
      }
    },
    setType (item) {
      // this.hideWait = (item !== 'simple');
      this.bookingType = this.form.fields.type = item;
      if (item !== 'to') {
        this.form.fields.retour = false;
        delete this.form.fields.retour;
      }
    },
    resetWait (d) {
      this.waittime = '0';
    },
    calcWaitPrice (data) {
      var t = (moment.duration(data, 'HH:mm').asMinutes()) / 30;
      this.form.fields.waitprice = this.waitprice = (t * 5);
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDates (dates) {
      if (!dates) {
        return null
      }
      return dates.map((date) => {
        var [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`
      })
    },
    unformatDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('/')
      return `${year}-${month}-${day}`
    },
    save () {
      if (this.$refs.form.validate() && this.validMutas()) {
        this.form.fields.ticket_price = this.form.fields.ticket_price || 0;
        this.form.fields.price = this.getPrice();
        this.form.fields.price_driver = this.getDriverPrice();
        this.form.fields.pick_time = this.getPickTime();
        if (this.pick_address.trim()) {
          this.form.fields.pick_address = this.pick_address;
        }
        if (this.mutual) {
          this.form.fields.mutualAmount = this.getMutualPrice();
        }
        this.$emit('save', this.form);
      }
    },
    update () {
      if (this.$refs.form.validate() && this.validMutas()) {
        this.form.fields.ticket_price = this.form.fields.ticket_price || 0;
        this.form.fields.price = this.getPrice();
        this.form.fields.price_driver = this.getDriverPrice();
        this.form.fields.pick_time = this.getPickTime();
        this.form.fields.charged = this.form.fields.status ? null : this.form.fields.charged;
        if (this.pick_address.trim()) {
          this.form.fields.pick_address = this.pick_address;
        }
        if (this.mutual) {
          this.form.fields.mutualAmount = this.getMutualPrice();
          this.form.fields.mutualDistance = this.getMutualDistance();
        }
        this.$emit('update', this.form);
      } else {
        console.log('form not valid');
      }
    },
    showMap () {
      var trip = [
        this.driverObj.address,
        this.pick_address,
        this.destinationObj.address
      ];
      this.$refs.routeMap.show(trip, true);
    },
    validMutas () {
      if (this.mutual) {
        return (this.form.fields.mutualAmount || this.form.fields.mutualDistance)
      } else {
        return true
      }
    },
    close () {
      this.$emit('close');
    },
    reset () {
      this.mutual = null;
      this.driverObj = null;
      this.clientObj = null;
      this.destinationObj = null;
      this.valid = false;
      this.factuur = false;
      this.factuurDriver = false;
      this.creditDriver = false;
      this.accepted = 0;
    },
    changePrice (v) {
      if (!this.factuur) {
        this.form.fields.price = this.form.fields.price_driver;
        this.$nextTick(() => {
          // this.$refs.price.value = this.form.fields.price_driver;
          console.log('re-render end')
        });
      }
    },
    onChange (e) {
      this.distance[e.id] = e;
      this.form.fields[e.id] = e.value;
      if (e.id === 'clientId') {
        this.factuur = this.form.fields.factuur = e.data.factuur || null;
        this.$refs.pickupAddressAdd.prefill(e.address);
      }
    },
    setAddress (v) {
      this.pick_address = v;
    },
    setPickup (v) {
      this.pick_address = v;
      this.distance.clientId.address = v;
    },
    removePickup (v) {
      console.log('remove pickup', v);
    },
    onChangeInsurance (e) {
      this.form.fields.insuranceId = e.value;
      this.form.fields.min10km = e.forfait.min10km;
      this.form.fields.plus10km = e.forfait.plus10km;
      // matchingState.price.elements
      // forfait10km 16
      // from11to30 1.78
      // above30 1.2
    },
    getData () {
      return new Promise((resolve, reject) => {
        this.getInsurances();
        this.getDrivers();
        this.getCients().then(() => {
          this.getDestinations().then(() => {
            resolve(true)
          });
        })
        .catch(function (error) {
          reject(error);
        });
      })
    },
    getPrice () {
      var app = this;
      return app.form.fields.price || app.form.fields.price_driver || app.distance_result.totals[app.form.fields.type].price;
    },
    getDriverPrice () {
      var app = this;
      return app.form.fields.price_driver || app.distance_result.totals[app.form.fields.type].price;
    },
    getMutualPrice () {
      var app = this;
      return Number(app.form.fields.mutualAmount) || 0;
    },
    getMutualDistance () {
      var app = this;
      if (!app.form.fields.mutualAmount) {
        return Number(app.form.fields.mutualDistance) || null;
      } else {
        return null
      }
    },
    getPickTime () {
      var app = this;
      var tempTime = 0;
      var pickTime = 0;
      var d = app.distance_result[app.form.fields.type];

      if (app.form.fields.type !== 'back') {
        tempTime += d[1].duration.value
        pickTime = moment(app.form.fields.ap_time, 'HH:mm').subtract(app.timeBefore, 'm').subtract(tempTime, 's').format('HH:mm');
      } else {
        pickTime = app.form.fields.ap_time;
      }

      return pickTime;
    },
    updateApTime (oldApTime) {
      var app = this;
      var tempTime = 0;
      var apTime = 0;
      var d = app.distance_result[app.form.fields.type];
      app.form.fields.pick_time = oldApTime;

      if (app.form.fields.type !== 'back') {
        tempTime = d[1].duration.value
        apTime = moment(app.form.fields.pick_time, 'HH:mm').add(app.timeBefore, 'm').add(tempTime, 's').format('HH:mm');
      } else {
        apTime = oldApTime;
      }
      app.form.fields.ap_time = apTime;
    },
    changeAccepted (value, id) {
      var app = this;

      if (this.booking.id) {
        this.$http
        .put('api/booking/' + id, {fields: {accepted: value }})
        .then(response => {
          app.$emit('refresh');
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      } else {
        app.form.fields.accepted = value;
      }
    },
    getDestinations () {
      // var app = this;
      return new Promise((resolve, reject) => {
        this.$http
        .get('api/destination')
        .then(response => {
          this.destinations = response.data.map(obj => {
            return {
              id: 'destinationId',
              text: obj.name,
              value: obj.id,
              address: obj.fullAddress
            }
          })
          resolve(this.destinations);
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    getInsurances () {
      return new Promise((resolve, reject) => {
        this.$http
        .get('api/insurance')
        .then(response => {
          this.insurances = response.data.map(obj => {
            return {
              id: 'insuranceId',
              text: obj.name,
              value: obj.id,
              forfait: {
                min10km: obj.min10km,
                plus10km: obj.plus10km
              }
            }
          });
          resolve(this.insurances);
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    getDrivers () {
      return new Promise((resolve, reject) => {
        this.$http
        .get('service/driver/active')
        .then(response => {
          this.drivers = response.data.map(obj => {
            return {
              id: 'driverId',
              text: obj.lastname + ' ' + obj.firstname,
              value: obj.id,
              address: obj.address + ', ' + obj.zip + ' ' + obj.city
            }
          });
          resolve(this.drivers);
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    getCients () {
      return new Promise((resolve, reject) => {
        this.$http
        .get('api/client')
        .then(response => {
          this.clients = response.data.map(obj => {
            return {
              id: 'clientId',
              text: obj.lastname + ' ' + obj.firstname + ' ' + obj.id,
              value: obj.id,
              address: obj.address + ', ' + obj.zip + ' ' + obj.city,
              data: {
                factuur: obj.factuur,
                price: obj.basePrice
              }

            }
          });
          resolve(this.clients);
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    getDistance: function () {
      var app = this;

      var data = [
        this.distance.driverId.address,
        this.distance.clientId.address,
        this.distance.destinationId.address
      ]

      this.$http
      .post('service/distance/get', data)
      .then(response => {
        // app.map.renderData(response.data)
        console.log('getDistance', response.data);
        app.form.fields.distance = app.distance_result = response.data;
        return response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getDirections: function () {
      var app = this;

      var data = {
        origin: this.distance.driverId.address,
        destination: this.distance.driverId.address,
        waypoints: [this.distance.clientId.address, this.distance.destinationId.address]
      }

      this.$http
      .post('service/distance/getDirections', data)
      .then(response => {
        // app.map.renderData(response.data)
        console.log('getDirections', response.data);
        app.form.fields.distance = app.distance_result = response.data;
        return response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    prefill (b) {
      console.log('-- prefill common ---', b);
      var app = this;
      var arr = ['client', 'driver', 'destination'];
      this.form.dates = this.dates = [];
      this.form.fields.factuur = false;
      this.form.fields.factuurDriver = false;
      this.form.fields.creditDriver = false;
      this.form.fields.type = null;
      this.form.fields.ap_time = null;
      this.form.fields.ap_date = null;
      this.form.fields.price = 0;
      this.form.fields.price_driver = 0;
      this.form.fields.ticket_price = 0;
      this.form.fields.motive = 0; // raison: none
      this.form.fields.comment = null;
      this.form.fields.accepted = 1; // pending
      this.form.back = null;
      // this.basePrice = null;
      arr.map(function (w) {
        var wObj = w + 'Obj';
        if (app[wObj] && app[wObj].id) {
          app.distance[app[wObj].id] = app[wObj];
          app.form.fields[app[wObj].id] = app[wObj].value;
        }
      })

      this.form.fields.distance = this.distance_result;
      this.dateFormatted = this.formatDate(this.form.fields.ap_date);

      this.setType(null);

      if (b) {
        this.form.fields.motive = this.booking.motive;
        this.form.fields.ap_time = this.booking.ap_time;
        this.form.fields.pick_time = this.booking.pick_time || this.booking.ap_time;
        this.form.fields.ap_date = this.unformatDate(this.booking.ap_date);
        this.form.dates = this.booking.dates || [];
        this.dateFormatted = this.booking.ap_date;
        if (b.back) {
          this.form.back = b.back;
        }
        if (b.driverId) {
          this.driverObj = this.drivers.find(function (obj) { return obj.value === b.driverId; });
          if (this.driverObj) {
            this.onChange(this.driverObj);
          } else {
            console.log('driver is not active', b.driverId);
          }
        }
        if (b.clientId) {
          this.clientObj = this.clients.find(function (obj) { return obj.value === b.clientId; });
          if (b.pick_address) {
            this.setPickup(b.pick_address);
          }
          this.onChange(this.clientObj);
        } else{
          this.$refs.pickupAddressAdd.clear();
        }

        if (b.destinationId) {
          this.destinationObj = this.destinations.find(function (obj) { return obj.value === b.destinationId; });
          this.onChange(this.destinationObj);
        }
        if (b.type) {
          this.setType(this.booking.type);
        }
        if (b.mutualPatientID) {
          this.mutual = true;
          this.form.fields.mutualPatientID = b.mutualPatientID;
          this.insuranceObj = this.insurances.find(function (obj) { return obj.value === b.insuranceId; });
          this.form.fields.insuranceId = b.insuranceId;
          this.form.fields.mutualComment = b.mutualComment || null;
          this.form.fields.mutualDistance = b.mutualDistance || null;
          this.form.fields.noMutIntervention = b.noMutIntervention || null;
          this.form.fields.certificateNeeded = b.certificateNeeded || null;
          this.form.fields.min10km = b.min10km;
          this.form.fields.plus10km = b.plus10km;
          this.form.fields.mutualPatientAmount = b.mutualPatientAmount;
          this.form.fields.mutualAmount = b.mutualAmount || null;
          this.nonReimbursed = b.nonReimbursed || {};
        }

      }
      setTimeout(() => {
        console.log('setTimeout initialized', app.initialized);
        app.initialized = true;
      }, 0);
    }
  },
  filters: {
    formatIndex (v, obj) {
      return obj[v];
    }
  },
  watch: {
    distance: {
      handler: function () {
        console.log('initialized', this.initialized,'distance:', this.distance);
        if (this.initialized && this.distance.driverId && this.distance.clientId && this.distance.destinationId) {
          // this.getDistance();
          this.getDirections();
        }
      },
      deep: true
    },
    factuur (value) {
      if (!this.factuur) {
        this.form.fields.price = this.form.fields.price_driver
      }
    },
    creditDriver (value) {
      if (!this.creditDriver) {
        this.form.fields.creditAmount = null;
        this.form.fields.creditReason = null;
      }
    },
    waittime (value) {
      this.form.fields.ap_waittime = value;
      this.calcWaitPrice(this.form.fields.ap_waittime);
    },
    dialog (value) {
      this.getData().then(() => {
        this.init(value);
      })
    }
  },
  computed: {
    basePrice: {
      cache: false,
      get () {
        return (this.clientObj && this.clientObj.data.price) || null
      }
    }
  },
  created () {}
}
